import { h } from '../../utils/dom.js';
export function Card(...children) {
  return h('div', { class: 'card' }, ...children);
}